export default {
  chat: 'Online chat',
  feedback: 'Feedback',
  feedbackForm: {
    title: 'What can be improved?',
    description:
      'Share your ideas, suggestions, or feedback. We want to develop edna Pulse in a way that helps efficiently solve your business needs.',
    hint: 'If you notice an issue in edna Pulse or need assistance, please contact us at <0>{{link}}</0>',
  },
  feedbackModal: {
    title: 'Thank you for your feedback!',
    description: 'Your input inspires the edna Pulse team to keep improving.',
  },
};
